/**
 * 
 * @param {String} api Trello Api URL
 * @param {String} key Trello Key
 * @param {String} token Trello Token
 * @returns All Boards Data
 */
export const getBoards = async (api, key, token) => {
    const res = await fetch(`${api}members/me/boards?key=${key}&token=${token}`)
    const data = await res.json()

    return data
}

/**
 * 
 * @param {String} board_name Board Name
 * @param {String} api Trello Api URL
 * @param {String} key Trello Key
 * @param {String} token Trello Token
 * @returns New Board Data
 */
export const createBoard = async (board_name, api, key, token) => {

    const promise = await fetch(`${api}boards/?key=${key}&token=${token}&name=${board_name}`, { method: 'POST' })
    const board = await promise.json();

    return board
}

/**
 * 
 * @param {String} boardId Board Id
 * @param {String} key Trello Key
 * @param {String} token Trello Token
 * @param {String} api Trello API
 * @returns Response of Deleted Board
 */
export const deleteBoard = async (boardId, key, token, api) => {
    const res = await fetch(`${api}boards/${boardId}?key=${key}&token=${token}`, { method: 'DELETE' })
    return res;
}


export const getBoard = async (boardId, api, key, token) => {

    try {

        let res = await fetch(`${api}boards/${boardId}?key=${key}&token=${token}`)
        const board = await res.json()

        // fetching lists of board
        res = await fetch(`${api}boards/${boardId}/lists?key=${key}&token=${token}`)
        const lists = await res.json()
        return { board, lists }

    } catch (error) {
        console.log(error);
    }

}


export const createList = async (name, idBoard, api, key, token) => {

    const promise = await fetch(`${api}lists?key=${key}&token=${token}&name=${name}&idBoard=${idBoard}`, { method: 'POST' })
    const list = await promise.json();

    return list
}

export const getCards = async (listId, api, key, token) => {

    try {

        let res = await fetch(`${api}lists/${listId}/cards?key=${key}&token=${token}`)
        const cards = await res.json()

        return cards

    } catch (error) {
        console.log(error);
    }

}

export const deleteCard = async (cardId, key, token, api) => {

    const res = await fetch(`${api}cards/${cardId}?key=${key}&token=${token}`, { method: 'DELETE' })
    return res;

}

export const updateCard = async (cardId, desc, api, key, token) => {

    const promise = await fetch(`${api}cards/${cardId}?key=${key}&token=${token}&desc=${desc}`, { method: 'PUT' });
    const card = await promise.json();

    return card
}

export const createCard = async (name, idList, api, key, token) => {

    const promise = await fetch(`${api}cards/?key=${key}&token=${token}&name=${name}&idList=${idList}`, { method: 'POST' })
    const card = await promise.json();

    return card

}

export const getCheckLists = async (cardId, key, token, api) => {
    const res = await fetch(`${api}cards/${cardId}/checklists?key=${key}&token=${token}`)

    const data = res.json();

    return data;
}

export const createChecklist = async (name, cardId, api, key, token) => {

    const promise = await fetch(`${api}cards/${cardId}/checklists?key=${key}&token=${token}&name=${name}`, { method: 'POST' });
    
    const checklist = await promise.json();

    return checklist;

}

export const deleteChecklist = async (cardId, idChecklist, api, key, token) => {

    const res = await fetch(`${api}cards/${cardId}/checklists/${idChecklist}?key=${key}&token=${token}`, { method: 'DELETE' })
    return res;

}

export const createCheckItem = async (name, checklistId, api, key, token) => {

    const promise = await fetch(`${api}checklists/${checklistId}/checkItems?key=${key}&token=${token}&name=${name}`, { method: 'POST' });

    const checkItem = await promise.json();

    return checkItem;
}


export const deleteCheckItem = async (checkItemId, idChecklist, api, key, token) => {

    const promise = await fetch(`${api}checklists/${idChecklist}/checkItems/${checkItemId}?key=${key}&token=${token}`, { method: 'DELETE' });

    return promise;
}

export const updateCheckItem = async (cardId, idChecklist, checkItemId, state, api, key, token) => {
    
    const promise = await fetch(`${api}cards/${cardId}/checklist/${idChecklist}/checkItem/${checkItemId}?key=${key}&token=${token}&state=${state}`, { method: 'PUT' });
    
    const checkItem = await promise.json()
    
    return checkItem
}
